module.exports = __webpack_public_path__ + "static/logo-150-ans-0848e13464f2ab5f6ad1b3de03f3cf1c.png";